const tommyMarquee = () => {
    const tommyMarqueeSections = document.querySelectorAll('[data-tommy-marquee]');
    tommyMarqueeSections.forEach((section) => {
        const updateParallax = () => {
            const container = section.querySelector('[data-tommy-container]');
            const image = container.querySelector('[data-tommy]');
            const rect = container.getBoundingClientRect();
            const containerCenter = rect.top + rect.height / 2;
            const viewportAnchor = window.innerHeight * 0.25;
            const distance = containerCenter - viewportAnchor;
            const offset = Math.max(0, distance * 0.2);
            image.style.transform = `translateY(${offset}px)`;
        };
        window.addEventListener('scroll', updateParallax);
        window.addEventListener('resize', updateParallax);
        updateParallax();
    });
};
export { tommyMarquee };
